<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (asLink) {
  <button type="button" class="button-link" (click)="launchReport()">{{label}}</button>
} @else {
  <button type="button" mat-button (click)="launchReport()">{{label}}</button>
}


